import styled from "styled-components";
import colors from "../../../../../css/colors";

export const Container = styled.div`
  background-color: ${colors.WHITE};

  .ant-table-wrapper {
    margin: 2em 0;
    border: 2px solid ${colors.GREY_LIGHT};
    border-radius: 6px;
  }
  .ant-table-thead > tr > th {
    background-color: ${colors.WHITE};
  }
  .ant-table-pagination.ant-pagination {
    margin: 16px;
  }
  .ant-table-footer {
    background-color: ${colors.WHITE};
    display: flex;
    justify-content: space-between;
  }
`;
